import {
  DashboardMeetingDetail,
  DashboardMeetingType,
  DashboardMeetingView,
} from "@/interfaces/DashboardMeetingStats";
import { DateTime } from "luxon";
import { FC } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import MeetingSourceCall from "./MeetingSourceCall";

const TYPE_LABELS: Record<DashboardMeetingType, string> = {
  "face-to-face": "Présentiel",
  phone: "Téléphonique",
  video: "Visio",
};
const date = (value: string) =>
  DateTime.fromISO(value, { zone: "Europe/Paris" }).toFormat("dd/MM/yyyy");
const time = (value: string) =>
  DateTime.fromISO(value, { zone: "Europe/Paris" }).toFormat("HH:mm");

const MeetingDetailsTable: FC<{
  rows: DashboardMeetingDetail[];
  view: DashboardMeetingView;
}> = ({ rows, view }) => (
  <Table
    responsive
    className="meeting-report-table mb-0"
    aria-label="Détail des rendez-vous"
  >
    <thead>
      <tr>
        <th scope="col">Client / Rendez-vous</th>
        <th scope="col">Calendrier</th>
        <th
          scope="col"
          className={view === "scheduled" ? "meeting-report-highlight" : ""}
        >
          Date et horaire du RDV
        </th>
        <th scope="col">Assuré par</th>
        <th scope="col">Pris par</th>
        <th
          scope="col"
          className={view === "booked" ? "meeting-report-highlight" : ""}
        >
          Date de prise
        </th>
        <th scope="col">Appel associé</th>
      </tr>
    </thead>
    <tbody>
      {rows.length ? (
        rows.map((row) => (
          <tr key={row.id}>
            <td>
              {row.companyId ? (
                <Link
                  to={`/companies/${row.companyId}?tab=${row.calendarType === "montage" ? "montage-meetings" : "meetings"}`}
                >
                  {row.companyName ?? "Entreprise"}
                </Link>
              ) : (
                <strong>{row.title || "Rendez-vous sans entreprise"}</strong>
              )}
              <small>
                {!row.companyId && "Sans entreprise · "}
                {TYPE_LABELS[row.type]}
              </small>
            </td>
            <td>
              <span
                className={`meeting-report-calendar meeting-report-calendar-${row.calendarType}`}
              >
                {row.calendarType === "montage" ? "Montage" : "Commercial"}
              </span>
            </td>
            <td
              className={view === "scheduled" ? "meeting-report-highlight" : ""}
            >
              <strong>{date(row.startAt)}</strong>
              <small>
                {time(row.startAt)} –{" "}
                {date(row.endAt) !== date(row.startAt) && `${date(row.endAt)} `}
                {time(row.endAt)}
              </small>
            </td>
            <td>{row.owner?.fullname ?? "Non attribué"}</td>
            <td>{row.author?.fullname ?? "Auteur non renseigné"}</td>
            <td className={view === "booked" ? "meeting-report-highlight" : ""}>
              {date(row.createdAt)}
              <small>à {time(row.createdAt)}</small>
            </td>
            <td>
              <MeetingSourceCall
                call={row.sourceCall}
                companyId={row.companyId}
              />
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={7} className="text-center py-5">
            Aucun rendez-vous pour cette période et ces filtres.
          </td>
        </tr>
      )}
    </tbody>
  </Table>
);

export default MeetingDetailsTable;
